import TextBlocks from '@/components/utilities/TextBlocks';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const SegmentationBlock = ({ segments }) => {
  return (
    <div className="mx-auto my-10 w-[90vw] text-center xl:w-(--container-width)">
      {segments.map((segment, index) => (
        <VisibleLoading key={segment.id} delay={(index + 1) * 100}>
          {({ ref, className }) => <SegmentationBlockItem innerRef={ref} className={className} {...segment} />}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default SegmentationBlock;

const COLORS = {
  brand: {
    text: 'text-brand-800',
    background: 'bg-brand-100 border-brand-500 hover:bg-brand-200',
    popover: 'bg-white border-brand-500'
  },
  blue: {
    text: 'text-blue-800',
    background: 'bg-blue-100 border-blue-500 hover:bg-blue-200',
    popover: 'bg-white/70 backdrop-blur-sm'
  },
  green: {
    text: 'text-green-800',
    background: 'bg-green-100 border-green-500 hover:bg-green-200',
    popover: 'bg-white border-green-500'
  },
  yellow: {
    text: 'text-yellow-800',
    background: 'bg-yellow-100 border-yellow-500 hover:bg-yellow-200',
    popover: 'bg-white border-yellow-500'
  },
  red: {
    text: 'text-red-800',
    background: 'bg-red-100 border-red-500 hover:bg-red-200',
    popover: 'bg-white border-red-500'
  },
  purple: {
    text: 'text-purple-800',
    background: 'bg-purple-100 border-purple-500 hover:bg-purple-200',
    popover: 'bg-white border-purple-500'
  }
};

const SegmentationBlockItem = ({ innerRef, className, title, count, description, color }) => {
  const {
    text: textColorClassName,
    background: backgroundColorClassName,
    popover: popoverColorClassName
  } = COLORS[color] || COLORS['brand'];

  return (
    <Popover>
      <div className={`inline-block ${!description ? 'pointer-events-none' : ''} ${className || ''}`.trim()}>
        <PopoverTrigger
          ref={innerRef}
          className={`txt-lg mx-2 my-2 inline-flex cursor-pointer items-center gap-3 rounded-full border-2 px-4 py-3 font-medium duration-300 ${backgroundColorClassName} ${textColorClassName}`}
        >
          <div>{title}</div>
          <div>|</div>
          <div className="text-grey-950 flex h-6 w-6 items-center justify-center rounded-[4px] bg-white/50">
            {count}
          </div>
        </PopoverTrigger>
        <PopoverContent
          className={`max-w-[90vw]! rounded-2xl border-none px-1 py-0 text-black shadow-2xl/15 md:min-w-[550px] lg:min-w-[650px] ${popoverColorClassName}`.trim()}
        >
          <div className="max-h-[400px] overflow-y-auto px-3">
            <h3 className={`heading-6 mt-4 mb-4 border-b-1 border-black/20 px-2 pb-2`}>{title}</h3>
            <div className={`txt-md px-2`}>
              <TextBlocks template={description} />
            </div>
          </div>
        </PopoverContent>
      </div>
    </Popover>
  );
};
